module.exports = __webpack_public_path__ + "static/media/klimbingkiosk1.2ed178fa.jpg";